import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: "",//process.env.MIX_PUSHER_APP_KEY,
//     cluster: "",
//     httpHost: process.env.MIX_LARAVEL_WEBSOCKETS_HOST,
//     httpPath: process.env.MIX_LARAVEL_WEBSOCKETS_PATH,
//     httpPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT,
//     wsHost: process.env.MIX_LARAVEL_WEBSOCKETS_HOST,
//     wsPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT,
//     wsPath: process.env.MIX_LARAVEL_WEBSOCKETS_PATH,
//     forceTLS: process.env.MIX_LARAVEL_FORCE_TLS == "true",
//     disableStats: false
// });
window.Echo = new Echo(
    {
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        wsHost: process.env.MIX_LARAVEL_WEBSOCKETS_HOST,
        wsPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT,
        wssPort: 443,
        wsPath: process.env.MIX_LARAVEL_WEBSOCKETS_PATH,
        disableStats: true,
        // enabledTransports: ['ws', 'wss'],
        // encrypted: false,//process.env.MIX_LARAVEL_FORCE_TLS,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        forceTLS: process.env.MIX_LARAVEL_FORCE_TLS == "true",
    });